const updates = {
	show: false,
};

export default updates;
